import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ConsoleLayout from "@/layouts/ConsoleLayout";
import Dashboard from "@/pages/console/Dashboard";
import Scheduler from "@/pages/console/Scheduler";
import Assets from "@/pages/console/Assets";
import Programs from "@/pages/console/Programs";
import BreakpointEditor from "@/pages/console/BreakpointEditor";
import RoleGuard from "@/components/RoleGuard";
import GraphicsEditor from "@/pages/console/GraphicsEditor";
import AdTemplates from "@/pages/console/AdTemplates";
import EPG from "@/pages/console/EPG";
import AsRunLogs from "@/pages/console/AsRunLogs";
import Polls from "@/pages/console/Polls";
import Monitoring from "@/pages/console/Monitoring";
import TenantSettings from "@/pages/console/TenantSettings";
import Users from "@/pages/console/Users";
import Pricing from "@/pages/console/Pricing";
import Billing from "@/pages/console/Billing";
import Clips from "@/pages/console/Clips";
import MagicWall from "@/pages/console/MagicWall";
import RevenueAnalytics from "@/pages/console/RevenueAnalytics";
import TenantsAdmin from "@/pages/console/admin/Tenants";
import AuditLogs from "@/pages/console/admin/AuditLogs";
import Hardware from "@/pages/console/Hardware";
import PublicPricing from "@/pages/Pricing";
import PublicHardware from "@/pages/Hardware";
import ProspectPage from "@/pages/ProspectPage";
import Watch from "@/pages/Watch";
import Clip from "@/pages/Clip";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { useAuth } from "@/lib/auth";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-zinc-500 font-mono text-xs">
        LOADING SESSION…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/pricing" element={<PublicPricing />} />
        <Route path="/hardware" element={<PublicHardware />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route
          path="/console"
          element={
            <Protected>
              <ConsoleLayout />
            </Protected>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="scheduler" element={<Scheduler />} />
          <Route path="assets" element={<Assets />} />
          <Route path="assets/:id/breakpoints" element={<BreakpointEditor />} />
          <Route path="clips" element={<RoleGuard route="/console/clips"><Clips /></RoleGuard>} />
          <Route path="programs" element={<Programs />} />
          <Route path="graphics" element={<GraphicsEditor />} />
          <Route path="magic-wall" element={<RoleGuard route="/console/magic-wall"><MagicWall /></RoleGuard>} />
          <Route path="ad-templates" element={<AdTemplates />} />
          <Route path="epg" element={<RoleGuard route="/console/epg"><EPG /></RoleGuard>} />
          <Route path="as-run" element={<AsRunLogs />} />
          <Route path="polls" element={<RoleGuard route="/console/polls"><Polls /></RoleGuard>} />
          <Route path="monitoring" element={<RoleGuard route="/console/monitoring"><Monitoring /></RoleGuard>} />
          <Route path="tenant" element={<RoleGuard route="/console/tenant"><TenantSettings /></RoleGuard>} />
          <Route path="users" element={<RoleGuard route="/console/users"><Users /></RoleGuard>} />
          <Route path="pricing" element={<RoleGuard route="/console/pricing"><Pricing /></RoleGuard>} />
          <Route path="billing" element={<RoleGuard route="/console/billing"><Billing /></RoleGuard>} />
          <Route path="admin/revenue" element={<RoleGuard route="/console/admin/revenue"><RevenueAnalytics /></RoleGuard>} />
          <Route path="admin/tenants" element={<RoleGuard route="/console/admin/tenants"><TenantsAdmin /></RoleGuard>} />
          <Route path="admin/audit-logs" element={<RoleGuard route="/console/admin/audit-logs"><AuditLogs /></RoleGuard>} />
          <Route path="hardware" element={<RoleGuard route="/console/hardware"><Hardware /></RoleGuard>} />
        </Route>
        <Route path="/p/:slug" element={<ProspectPage />} />
        <Route path="/watch/:slug" element={<Watch />} />
        <Route path="/clip/:id" element={<Clip />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
